import API from '../AxiosInstance';

export default {
  getFtpUserList: function(rootNodeId) {
    const options = {};
    return API.get(`tenants/${rootNodeId}/ftpusers`, options);
  },

  getFtpUsersByUser: function(rootNodeId, userId) {
    const options = {};
    return API.get(`tenants/${rootNodeId}/ftpusers/${userId}`, options);
  },

  createFtpUser: function(rootNodeId, payload) {
    return API.post(`tenants/${rootNodeId}/ftpusers`, payload);
  },

  updateFtpUser: function(rootNodeId, ftpUserId, payload) {
    return API.patch(`tenants/${rootNodeId}/ftpusers/${ftpUserId}`, payload);
  },

  deleteFtpUser: function(rootNodeId, ftpUserId) {
    return API.delete(`tenants/${rootNodeId}/ftpusers/${ftpUserId}`);
  },

  getAffectedFtpUsers: function(rootNodeId, nodeIds) {
    return API.post(`tenants/${rootNodeId}/ftpusers/affected`, { nodeids: nodeIds });
  }
}
